/**
 * Log level types
 */
export type LogLevel = "debug" | "info" | "warn" | "error";

/**
 * Development environment configuration
 */
export const developmentConfig = {
  // API Configuration
  apiTimeout: 30000,
  enableMockData: true,
  enableDebugMode: true,

  // Logging Configuration
  logLevel: "debug" as LogLevel,
  enableConsoleLogging: true,
  enableNetworkLogging: true,

  // Performance Configuration
  enablePerformanceMonitoring: true,
  enableSourceMaps: true,

  // Feature Flags
  features: {
    enableNewUI: true,
    enableExperimentalFeatures: true,
    enableBetaFeatures: false,
  },

  // Development Tools
  enableDevTools: true,
  enableHotReload: true,
  enableErrorBoundary: true,

  // Cache Configuration
  cacheTimeout: 5 * 60 * 1000, // 5 minutes
  enableCaching: false, // Disable caching in development
};

export type EnvironmentConfig = typeof developmentConfig;
